import { render, staticRenderFns } from "./WidgetReservation.vue?vue&type=template&id=87656662&"
import script from "./WidgetReservation.vue?vue&type=script&lang=js&"
export * from "./WidgetReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87656662')) {
      api.createRecord('87656662', component.options)
    } else {
      api.reload('87656662', component.options)
    }
    module.hot.accept("./WidgetReservation.vue?vue&type=template&id=87656662&", function () {
      api.rerender('87656662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/WidgetReservation.vue"
export default component.exports